import "../_lib/stacktable/stacktable.custom.js"
import "../_lib/datatables/datatables.js"

function showHideStackedTables(tables) {
    tables.each(function () {
        $(this).show();

        if ($(this).width() > $(this).parent().width()) {
            $(this).hide();

            if ($(this).prev().hasClass('card-table-container'))
                $(this).prev().show();
        }

        else {
            $(this).show();

            if ($(this).prev().hasClass('card-table-container'))
                $(this).prev().hide();
        }
    });
}

$(document).ready(function () {

    //DISABLE IN WEB EDIT
    if ($("body").hasClass("website-state-edit")) return;

    $('table.table-sortable').each(function() {
        var thisTable = $(this);
        var thisDataTable = thisTable.DataTable({
            "autoWidth": false
    });

        thisDataTable.on('draw.dt', function() {
            if (thisTable.hasClass('table-responsive')) {
                thisTable.removeClass('large-only').removeClass('stacktable').prev().remove();
                thisTable.cardtable({ myClass: 'card-table-container' });
                showHideStackedTables(thisTable);
            }
            
        });

    });

    // ADD SORTING AND FILTERING TO TABLES WITH table-sortable CLASS
    //var sortableSourceTables = $('table.table-sortable');
    //sortableSourceTables.DataTable();

    //$('#myTable').on( 'draw.dt', function () {
    //    alert( 'Table redrawn' );
    //} );

    // ADD STACKTABLE TO TABLES WITH table-responsive CLASS
    var responsiveSourceTables = $('table.table-responsive');
    responsiveSourceTables.cardtable({ myClass: 'card-table-container' });

    responsiveSourceTables = $('table.table-responsive.large-only');
    showHideStackedTables(responsiveSourceTables);

    $(window).resize(function () {
        showHideStackedTables(responsiveSourceTables);
    });
});